const YoutubeElementModel = {
  url: '',
  autoPlay: '',
};

export default YoutubeElementModel;
